import 'configs/i18n';
import $ from 'jquery';

import 'assets/fonts/fonts.css';
import './index.css';
import 'react-virtualized/styles.css';

import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
} from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';

import { store, persistor } from 'store';
import { themeInstance } from 'configs';
import { disabledProdConsole } from './utils';

import WebFont from 'webfontloader';

import reportWebVitals from './reportWebVitals';

declare module 'react' {
  // augment React types
  function memo<A, B>(
    Component: (props: A) => B
  ): (props: A) => ReactElement | null;
  // return type is same as ReturnType<ExoticComponent<any>>

  function forwardRef<T, P = {}>(
    render: (props: P, ref: React.Ref<T>) => React.ReactElement | null
  ): (props: P & React.RefAttributes<T>) => React.ReactElement | null;
}

(window as any).jQuery = $;

disabledProdConsole();

async function start() {
  const App = (await import('./containers/app')).default;
  const External = (await import('./containers/pages/external')).default;
  const ExpiredLink = (await import('./pages/expired-link')).default;

  ReactDOM.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={themeInstance}>
          <Router>
            <Switch>
              <Route path="/external" component={External} exact />
              <Route
                path="/"
                component={() => {
                  const { search } = useLocation();

                  const searchParams = new URLSearchParams(search);
                  const process = searchParams.get('process');

                  if (process === 'LinkExpired') {
                    return <ExpiredLink />;
                  }

                  return <App />;
                }}
              />
            </Switch>
          </Router>
        </ThemeProvider>
      </PersistGate>
    </Provider>,
    document.getElementById('root')
  );
}

WebFont.load({
  active: start,
  inactive: start,
  custom: {
    families: ['NeoSansStd'],
  },
});

reportWebVitals();
